export interface OpenMailtoParams {
    /** Email получателя. Если не указан, открывается письмо без предзаполненного получателя. */
    email?: string;
    /** Тема письма */
    subject: string;
    /** Тело письма */
    body?: string;
}

/**
 * Открывает почтовый клиент по ссылке mailto с указанными параметрами.
 */
export const openMailto = (params: OpenMailtoParams): void => {
    const { email = '', subject, body } = params;
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = body ? encodeURIComponent(body) : '';

    const mailtoLink = email
        ? `mailto:${email}?subject=${encodedSubject}${encodedBody ? `&body=${encodedBody}` : ''}`
        : `mailto:?subject=${encodedSubject}${encodedBody ? `&body=${encodedBody}` : ''}`;

    window.location.href = mailtoLink;
};
